import ContainerSimple from "./ContainerSimple"

export default function ModalSimple({children, showModal, setShowModal}) {

  if(showModal) {
    return(
      <div
        className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm py-6 overflow-hidden"
        onClick={() => setShowModal(false)}
      >
        <div
          className="w-11/12 max-w-2xl h-fit max-h-[calc(100vh-3rem)] min-h-0"
          onClick={(e) => e.stopPropagation()}
        >
          {/* <ContainerSimple onClose={() => setShowModal(false)} /> */}
          {children}
        </div>
      </div>
    )
  }
}